module.exports = __webpack_public_path__ + "assets/BtnDown.268c4724.svg";